/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestDto } from '../../models/test-dto';

export interface FixDocumentControllerAiTest$Params {
}

export function fixDocumentControllerAiTest(http: HttpClient, rootUrl: string, params?: FixDocumentControllerAiTest$Params, context?: HttpContext): Observable<StrictHttpResponse<TestDto>> {
  const rb = new RequestBuilder(rootUrl, fixDocumentControllerAiTest.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestDto>;
    })
  );
}

fixDocumentControllerAiTest.PATH = '/api/fix-document/ai-test';
